export const DD_MM_YYYY = "DD/MM/YYYY";
export const ddMMyyyy = "dd/MM/yyyy";
export const MM_DD_YYYY = "MM/DD/YYYY";
export const MMddyyyy = "MM/dd/yyyy";
